import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PlayIcon = props => (
  <Icon viewBox="0 0 512 512" color="inherit" h="full" w="full" {...props}>
    <g>
      <path
        d="M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472
		c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"
      />
      <polygon points="192,336 352,256 192,176 	" />
    </g>
  </Icon>
);
